module.exports = __webpack_public_path__ + "img/icon_kefu-n1.ec3691b3.png";